import { apiController } from '@isomorphic/utils/apiController';
import { userConstants } from '../constants/user.constants';
import { validateEmail } from '../utils';

const request = (user) => ({ type: userConstants.LOGIN_REQUEST, user });
const success = (user) => ({ type: userConstants.LOGIN_SUCCESS, user });
const failure = (error) => ({ type: userConstants.LOGIN_FAILURE, error });
export const setUserAction = (userId) => request({ userId });
export const loginAction = (username, password, history, errorCallback) => (dispatch) => {
	dispatch(request({ username }));

	const callback = (user) => {
		dispatch(success(user));
		const { loginRedirectionLink } = user?.data || {};
		if (loginRedirectionLink) {
			open(loginRedirectionLink, '_parent');
		}
 else {
			// todo fix it by adding API call on AppContainer
			open('/home', '_parent');
		}
	};

	const callbackError = (baseError) => {
		if (!baseError) {
			errorCallback();
		}
		const errors = baseError?.downStreamErrorDetails;
		if (Array.isArray(errors) && errors.length > 0) {
			dispatch(failure(errors));
			errorCallback(errors);
		}
	};
	const payload = validateEmail(username) ? { email: username, password } : { loginid: username, password };

	apiController(
		'POST', // TODO change method
		'Q2tClientApiUrl',
		'/login',
		payload,
		true,
		callback,
		callbackError
	);
};
